import { useState } from "react";

export function useWebhookDeleteDialog() {
  const [open, setOpen] = useState(false);

  return {
    open,
    setOpen,
  };
}
